import { addSavedOffer } from '@cian/favorites-assign-widget';

import { TThunkAction } from '../../types/redux';
import { TRecommendation } from '../../types/recommendation';
import { addToFavorite as addToFavoriteService } from '../../services/favorites';
import { toggleFavorite } from '../../actions/recommendations';

export function addToFavorite(recommendation: TRecommendation): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: true }));

    try {
      const response = await addToFavoriteService(context, {
        dealType: recommendation.dealType,
        offerId: recommendation.offerId,
        offerType: recommendation.offerType,
      });

      const folder = response.folder;
      const savedInFolders =
        folder && folder.name && folder.id
          ? [
              {
                id: folder.id,
                name: folder.name,
              },
            ]
          : null;

      dispatch(
        addSavedOffer({
          offerIds: [recommendation.offerId],
          savedInFolders,
          userHasFolders: Boolean(response.hasFolders),
        }),
      );
    } catch (error) {
      dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: false }));

      throw error;
    }
  };
}
